import { configureStore } from "@reduxjs/toolkit";
import layoutReducer from "./layoutStore";

export const store = configureStore({
    reducer: {
        layout: layoutReducer,
    },
});

export type RootState = ReturnType<typeof store.getState>;